var $34d4fb50bccc88c2$exports = {};
$34d4fb50bccc88c2$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$34d4fb50bccc88c2$exports as default};
//# sourceMappingURL=de-DE.mjs.map
